<mat-toolbar
  color="primary"
  class="header">
  <div class="menu">
    <button
      mat-button
      (click)="toggleMenuHandler()">
      <mat-icon>menu</mat-icon>
    </button>
    <div
      class="app-title"
      [routerLink]="['']">
      {{ 'Archivio Igor Mitoraj' }}
    </div>
    <span class="app-version">
    {{ 'Versione' | translate }} {{ version }}
  </span>
  </div>
  <div class="global-actions">
    <span>{{ username$ | async }}</span>
    <button
      mat-button
      class="settings"
      (click)="settingsHandler()">
      <mat-icon>settings_applications</mat-icon>
    </button>
    <button
      mat-button
      (click)="logoutHandler()">
      <mat-icon>exit_to_app</mat-icon>
    </button>
  </div>
</mat-toolbar>
